window.HMCT_THREAD_LIBRARY = [
  {
    "brand": "Madeira",
    "number": "1502",
    "name": "Zipper",
    "hex": "#5D5A6D"
  },
  {
    "brand": "Madeira",
    "number": "1505",
    "name": "Polished Silver",
    "hex": "#A6A4AD"
  },
  {
    "brand": "Madeira",
    "number": "1506",
    "name": "Deep Steel Blue",
    "hex": "#252839"
  },
  {
    "brand": "Madeira",
    "number": "1507",
    "name": "Pea Coat Lining",
    "hex": "#0D0D19"
  },
  {
    "brand": "Madeira",
    "number": "1508",
    "name": "Cherry Pie",
    "hex": "#A20009"
  },
  {
    "brand": "Madeira",
    "number": "1509",
    "name": "Rhubarb",
    "hex": "#B91F38"
  },
  {
    "brand": "Madeira",
    "number": "1521",
    "name": "Autumn Orange",
    "hex": "#E26F28"
  },
  {
    "brand": "Madeira",
    "number": "1522",
    "name": "Lavender Blue",
    "hex": "#7262AB"
  },
  {
    "brand": "Madeira",
    "number": "1526",
    "name": "French Vanilla",
    "hex": "#E3CB88"
  },
  {
    "brand": "Madeira",
    "number": "1527",
    "name": "Teddy Bear",
    "hex": "#C28B5B"
  },
  {
    "brand": "Madeira",
    "number": "1528",
    "name": "Serene Sky",
    "hex": "#297ECB"
  },
  {
    "brand": "Madeira",
    "number": "1529",
    "name": "Orchid Mist",
    "hex": "#AEA7BB"
  },
  {
    "brand": "Madeira",
    "number": "1531",
    "name": "Delphinium",
    "hex": "#3256A4"
  },
  {
    "brand": "Madeira",
    "number": "1532",
    "name": "Little Boy Blue",
    "hex": "#5584C0"
  },
  {
    "brand": "Madeira",
    "number": "1535",
    "name": "Tarnished Taupe",
    "hex": "#86735F"
  },
  {
    "brand": "Madeira",
    "number": "1538",
    "name": "Tiramisu",
    "hex": "#916F41"
  },
  {
    "brand": "Madeira",
    "number": "1539",
    "name": "Stone",
    "hex": "#4A3E3E"
  },
  {
    "brand": "Madeira",
    "number": "1540",
    "name": "Cobblestone",
    "hex": "#383639"
  },
  {
    "brand": "Madeira",
    "number": "1541",
    "name": "Chartreuse",
    "hex": "#E3E45F"
  },
  {
    "brand": "Madeira",
    "number": "1542",
    "name": "Blue Heather",
    "hex": "#5A75B6"
  },
  {
    "brand": "Madeira",
    "number": "1544",
    "name": "Chimney Smoke",
    "hex": "#434758"
  },
  {
    "brand": "Madeira",
    "number": "1545",
    "name": "Winter Mint",
    "hex": "#D2DFDD"
  },
  {
    "brand": "Madeira",
    "number": "1548",
    "name": "Pink Plush",
    "hex": "#FFA4C6"
  },
  {
    "brand": "Madeira",
    "number": "1549",
    "name": "Pink Sorbet",
    "hex": "#FBC7D4"
  },
  {
    "brand": "Madeira",
    "number": "1550",
    "name": "Light Periwinkle",
    "hex": "#CAD4EB"
  },
  {
    "brand": "Madeira",
    "number": "1552",
    "name": "Golden Green",
    "hex": "#BDB457"
  },
  {
    "brand": "Madeira",
    "number": "1553",
    "name": "Galaxy Blue",
    "hex": "#281D3F"
  },
  {
    "brand": "Madeira",
    "number": "1554",
    "name": "Dogwood",
    "hex": "#E7D4CE"
  },
  {
    "brand": "Madeira",
    "number": "1555",
    "name": "Carbon Paper",
    "hex": "#0D0B1B"
  },
  {
    "brand": "Madeira",
    "number": "1556",
    "name": "Taste of Honey",
    "hex": "#D79F76"
  },
  {
    "brand": "Madeira",
    "number": "1557",
    "name": "Mud Facial",
    "hex": "#271811"
  },
  {
    "brand": "Madeira",
    "number": "1558",
    "name": "French Roast",
    "hex": "#281816"
  },
  {
    "brand": "Madeira",
    "number": "1559",
    "name": "Mud Pie",
    "hex": "#1F1111"
  },
  {
    "brand": "Madeira",
    "number": "1560",
    "name": "Espresso",
    "hex": "#130D0D"
  },
  {
    "brand": "Madeira",
    "number": "1561",
    "name": "Cornmeal",
    "hex": "#F5E5B5"
  },
  {
    "brand": "Madeira",
    "number": "1562",
    "name": "Blue Hydrangea",
    "hex": "#A2BCE2"
  },
  {
    "brand": "Madeira",
    "number": "1563",
    "name": "Icy Blue",
    "hex": "#CCD8E6"
  },
  {
    "brand": "Madeira",
    "number": "1564",
    "name": "Dark Pewter",
    "hex": "#393846"
  },
  {
    "brand": "Madeira",
    "number": "1565",
    "name": "Irish Coffee",
    "hex": "#67350C"
  },
  {
    "brand": "Madeira",
    "number": "1566",
    "name": "Brilliant Blue",
    "hex": "#001C84"
  },
  {
    "brand": "Madeira",
    "number": "1567",
    "name": "Pickled Beet",
    "hex": "#520819"
  },
  {
    "brand": "Madeira",
    "number": "1568",
    "name": "Granite Green",
    "hex": "#978D69"
  },
  {
    "brand": "Madeira",
    "number": "1569",
    "name": "Hemlock",
    "hex": "#605941"
  },
  {
    "brand": "Madeira",
    "number": "1572",
    "name": "Winter Gray",
    "hex": "#A69EAD"
  },
  {
    "brand": "Madeira",
    "number": "1573",
    "name": "Vintage Lace",
    "hex": "#B89C8F"
  },
  {
    "brand": "Madeira",
    "number": "1574",
    "name": "Dark Slate Blue",
    "hex": "#171624"
  },
  {
    "brand": "Madeira",
    "number": "1575",
    "name": "Iron Gray",
    "hex": "#666875"
  },
  {
    "brand": "Madeira",
    "number": "1577",
    "name": "Dark Blue Turquoise",
    "hex": "#017DC3"
  },
  {
    "brand": "Madeira",
    "number": "1578",
    "name": "Faded Jade",
    "hex": "#80A4A2"
  },
  {
    "brand": "Madeira",
    "number": "1580",
    "name": "Jungle Green",
    "hex": "#055D4D"
  },
  {
    "brand": "Madeira",
    "number": "1582",
    "name": "White Linen",
    "hex": "#E3D9CF"
  },
  {
    "brand": "Madeira",
    "number": "1584",
    "name": "Deep Pink",
    "hex": "#DE3562"
  },
  {
    "brand": "Madeira",
    "number": "1588",
    "name": "Salsa",
    "hex": "#E61806"
  },
  {
    "brand": "Madeira",
    "number": "1589",
    "name": "Ebony",
    "hex": "#23222A"
  },
  {
    "brand": "Madeira",
    "number": "1592",
    "name": "Misty Mint",
    "hex": "#CDD9DF"
  },
  {
    "brand": "Madeira",
    "number": "1593",
    "name": "Blue Macaw",
    "hex": "#0197DB"
  },
  {
    "brand": "Madeira",
    "number": "1594",
    "name": "Cool Aqua",
    "hex": "#5BC3DF"
  },
  {
    "brand": "Madeira",
    "number": "1595",
    "name": "Fluorescent Pink",
    "hex": "#FB3D65"
  },
  {
    "brand": "Madeira",
    "number": "1596",
    "name": "Fluorescent Pink",
    "hex": "#F9005F"
  },
  {
    "brand": "Madeira",
    "number": "1597",
    "name": "Fluorescent Pink",
    "hex": "#FF3796"
  },
  {
    "brand": "Madeira",
    "number": "1598",
    "name": "Fluorescent Orange",
    "hex": "#FD5A00"
  },
  {
    "brand": "Madeira",
    "number": "1599",
    "name": "Fluorescent Green",
    "hex": "#95F518"
  },
  {
    "brand": "Madeira",
    "number": "1610",
    "name": "Silver",
    "hex": "#D3D4D9"
  },
  {
    "brand": "Madeira",
    "number": "1611",
    "name": "Smoke",
    "hex": "#B3B6C9"
  },
  {
    "brand": "Madeira",
    "number": "1612",
    "name": "Steel Gray",
    "hex": "#A6AFCE"
  },
  {
    "brand": "Madeira",
    "number": "1613",
    "name": "Gull Gray",
    "hex": "#8C96A1"
  },
  {
    "brand": "Madeira",
    "number": "1614",
    "name": "Twister",
    "hex": "#625F6C"
  },
  {
    "brand": "Madeira",
    "number": "1615",
    "name": "Battleship",
    "hex": "#74707F"
  },
  {
    "brand": "Madeira",
    "number": "1616",
    "name": "Conch Shell",
    "hex": "#F6746A"
  },
  {
    "brand": "Madeira",
    "number": "1617",
    "name": "Slate Purple",
    "hex": "#5B4A60"
  },
  {
    "brand": "Madeira",
    "number": "1618",
    "name": "Gun Powder",
    "hex": "#7B748F"
  },
  {
    "brand": "Madeira",
    "number": "1619",
    "name": "Granite",
    "hex": "#5A556A"
  },
  {
    "brand": "Madeira",
    "number": "1620",
    "name": "Light Salmon",
    "hex": "#FB9E99"
  },
  {
    "brand": "Madeira",
    "number": "1621",
    "name": "Rust",
    "hex": "#CA4507"
  },
  {
    "brand": "Madeira",
    "number": "1622",
    "name": "Parchment",
    "hex": "#F2E8CE"
  },
  {
    "brand": "Madeira",
    "number": "1623",
    "name": "Daffodil",
    "hex": "#F7E111"
  },
  {
    "brand": "Madeira",
    "number": "1624",
    "name": "Egg Yolk",
    "hex": "#FDC500"
  },
  {
    "brand": "Madeira",
    "number": "1625",
    "name": "Butterscotch",
    "hex": "#DFA000"
  },
  {
    "brand": "Madeira",
    "number": "1626",
    "name": "Peaches 'N' Cream",
    "hex": "#FBDD86"
  },
  {
    "brand": "Madeira",
    "number": "1627",
    "name": "Dusty Lilac",
    "hex": "#867299"
  },
  {
    "brand": "Madeira",
    "number": "1628",
    "name": "Worn Denim",
    "hex": "#8EAED7"
  },
  {
    "brand": "Madeira",
    "number": "1629",
    "name": "Ice",
    "hex": "#D2D1E3"
  },
  {
    "brand": "Madeira",
    "number": "1630",
    "name": "Lavendula",
    "hex": "#B9B0DB"
  },
  {
    "brand": "Madeira",
    "number": "1631",
    "name": "Velvet Violet",
    "hex": "#8A4F9F"
  },
  {
    "brand": "Madeira",
    "number": "1632",
    "name": "Blackberry Purple",
    "hex": "#231530"
  },
  {
    "brand": "Madeira",
    "number": "1633",
    "name": "Purple Passion",
    "hex": "#39003E"
  },
  {
    "brand": "Madeira",
    "number": "1634",
    "name": "Grape Jelly",
    "hex": "#1D0F38"
  },
  {
    "brand": "Madeira",
    "number": "1635",
    "name": "Burgundy",
    "hex": "#551120"
  },
  {
    "brand": "Madeira",
    "number": "1637",
    "name": "Cinnamon Candy",
    "hex": "#B70007"
  },
  {
    "brand": "Madeira",
    "number": "1638",
    "name": "Barn Red",
    "hex": "#8A081A"
  },
  {
    "brand": "Madeira",
    "number": "1639",
    "name": "Cinnabar",
    "hex": "#A61617"
  },
  {
    "brand": "Madeira",
    "number": "1640",
    "name": "Lead",
    "hex": "#555060"
  },
  {
    "brand": "Madeira",
    "number": "1641",
    "name": "Obsidian",
    "hex": "#18171D"
  },
  {
    "brand": "Madeira",
    "number": "1642",
    "name": "Lapis",
    "hex": "#1D49A3"
  },
  {
    "brand": "Madeira",
    "number": "1643",
    "name": "Navy",
    "hex": "#20364C"
  },
  {
    "brand": "Madeira",
    "number": "1645",
    "name": "Light Mint",
    "hex": "#76C3C7"
  },
  {
    "brand": "Madeira",
    "number": "1647",
    "name": "Mantis",
    "hex": "#A1CBB9"
  },
  {
    "brand": "Madeira",
    "number": "1648",
    "name": "Celery",
    "hex": "#97AF65"
  },
  {
    "brand": "Madeira",
    "number": "1649",
    "name": "Granny Smith",
    "hex": "#5A9E00"
  },
  {
    "brand": "Madeira",
    "number": "1650",
    "name": "Fresh Pine",
    "hex": "#107211"
  },
    {
    "brand": "Madeira",
    "number": "1651",
    "name": "Celtic Green",
    "hex": "#007838"
  },
  {
    "brand": "Madeira",
    "number": "1652",
    "name": "Mermaid",
    "hex": "#2B6B84"
  },
  {
    "brand": "Madeira",
    "number": "1653",
    "name": "Light Coral",
    "hex": "#F7D0BB"
  },
  {
    "brand": "Madeira",
    "number": "1654",
    "name": "Cocoa",
    "hex": "#5A3B3E"
  },
  {
    "brand": "Madeira",
    "number": "1656",
    "name": "Fawn",
    "hex": "#DFB6A1"
  },
  {
    "brand": "Madeira",
    "number": "1657",
    "name": "Golden Oak",
    "hex": "#804E36"
  },
  {
    "brand": "Madeira",
    "number": "1658",
    "name": "Mocha",
    "hex": "#77381B"
  },
  {
    "brand": "Madeira",
    "number": "1659",
    "name": "Coffee Bean",
    "hex": "#5B392B"
  },
  {
    "brand": "Madeira",
    "number": "1660",
    "name": "Sand Castle",
    "hex": "#CBBBBE"
  },
  {
    "brand": "Madeira",
    "number": "1661",
    "name": "Moonbeam",
    "hex": "#F8F0DB"
  },
  {
    "brand": "Madeira",
    "number": "1662",
    "name": "Slate",
    "hex": "#A59991"
  },
  {
    "brand": "Madeira",
    "number": "1663",
    "name": "Clove",
    "hex": "#614E43"
  },
  {
    "brand": "Madeira",
    "number": "1664",
    "name": "Graphite",
    "hex": "#676767"
  },
  {
    "brand": "Madeira",
    "number": "1665",
    "name": "Coal",
    "hex": "#454845"
  },
  {
    "brand": "Madeira",
    "number": "1666",
    "name": "Cornsilk",
    "hex": "#F8EAC8"
  },
  {
    "brand": "Madeira",
    "number": "1668",
    "name": "Silver Sage",
    "hex": "#617268"
  },
  {
    "brand": "Madeira",
    "number": "1669",
    "name": "Rosemary",
    "hex": "#363B35"
  },
  {
    "brand": "Madeira",
    "number": "1670",
    "name": "Vegas Gold",
    "hex": "#EEC15E"
  },
  {
    "brand": "Madeira",
    "number": "1671",
    "name": "Country Kitchen Blue",
    "hex": "#517AB4"
  },
  {
    "brand": "Madeira",
    "number": "1672",
    "name": "Toasted Almond",
    "hex": "#BC8B0D"
  },
  {
    "brand": "Madeira",
    "number": "1673",
    "name": "Khaki",
    "hex": "#B68D4D"
  },
  {
    "brand": "Madeira",
    "number": "1674",
    "name": "Light Denim",
    "hex": "#B0C8E4"
  },
  {
    "brand": "Madeira",
    "number": "1675",
    "name": "Nordic Blue",
    "hex": "#9EC1E9"
  },
  {
    "brand": "Madeira",
    "number": "1676",
    "name": "Hanukkah Blue",
    "hex": "#1E378C"
  },
  {
    "brand": "Madeira",
    "number": "1677",
    "name": "Mallard Teal",
    "hex": "#184654"
  },
  {
    "brand": "Madeira",
    "number": "1678",
    "name": "Pumpkin",
    "hex": "#FB5404"
  },
  {
    "brand": "Madeira",
    "number": "1680",
    "name": "Purple Heart",
    "hex": "#4C2A52"
  },
  {
    "brand": "Madeira",
    "number": "1681",
    "name": "Azalea",
    "hex": "#BF1B38"
  },
  {
    "brand": "Madeira",
    "number": "1682",
    "name": "Tusk",
    "hex": "#DACABA"
  },
  {
    "brand": "Madeira",
    "number": "1683",
    "name": "Lemon Drop",
    "hex": "#F6CC00"
  },
  {
    "brand": "Madeira",
    "number": "1684",
    "name": "Wheat Gold",
    "hex": "#CCAE72"
  },
  {
    "brand": "Madeira",
    "number": "1685",
    "name": "Tree Frog",
    "hex": "#03869E"
  },
  {
    "brand": "Madeira",
    "number": "1686",
    "name": "Mist",
    "hex": "#DBD9DC"
  },
  {
    "brand": "Madeira",
    "number": "1687",
    "name": "Sterling Silver",
    "hex": "#D0CFD5"
  },
  {
    "brand": "Madeira",
    "number": "1689",
    "name": "Shark",
    "hex": "#71656F"
  },
  {
    "brand": "Madeira",
    "number": "1690",
    "name": "Deep Sea",
    "hex": "#325560"
  },
  {
    "brand": "Madeira",
    "number": "1692",
    "name": "Limestone",
    "hex": "#AFCCD1"
  },
  {
    "brand": "Madeira",
    "number": "1694",
    "name": "Caribbean Blue",
    "hex": "#03A5CB"
  },
  {
    "brand": "Madeira",
    "number": "1695",
    "name": "Cyan",
    "hex": "#0077B9"
  },
  {
    "brand": "Madeira",
    "number": "1701",
    "name": "Spring Green",
    "hex": "#28B90E"
  },
  {
    "brand": "Madeira",
    "number": "1702",
    "name": "Spearmint",
    "hex": "#83CC9C"
  },
  {
    "brand": "Madeira",
    "number": "1703",
    "name": "Fir",
    "hex": "#2B604E"
  },
  {
    "brand": "Madeira",
    "number": "1704",
    "name": "Evergreen",
    "hex": "#244442"
  },
  {
    "brand": "Madeira",
    "number": "1705",
    "name": "Fresh Oregano",
    "hex": "#13140D"
  },
  {
    "brand": "Madeira",
    "number": "1706",
    "name": "Guacamole",
    "hex": "#8E8E1F"
  },
  {
    "brand": "Madeira",
    "number": "1707",
    "name": "Honeysuckle",
    "hex": "#D03233"
  },
  {
    "brand": "Madeira",
    "number": "1709",
    "name": "Shocking Pink",
    "hex": "#D808A7"
  },
  {
    "brand": "Madeira",
    "number": "1710",
    "name": "Magenta",
    "hex": "#92015C"
  },
  {
    "brand": "Madeira",
    "number": "1711",
    "name": "Lavender",
    "hex": "#B08EC9"
  },
  {
    "brand": "Madeira",
    "number": "1712",
    "name": "Lilac",
    "hex": "#B975B2"
  },
  {
    "brand": "Madeira",
    "number": "1713",
    "name": "Peach Blush",
    "hex": "#E5C4C2"
  },
  {
    "brand": "Madeira",
    "number": "1718",
    "name": "Overcast Grey",
    "hex": "#9D9FAE"
  },
  {
    "brand": "Madeira",
    "number": "1719",
    "name": "Chokecherry",
    "hex": "#63225C"
  },
  {
    "brand": "Madeira",
    "number": "1720",
    "name": "Plum",
    "hex": "#581B44"
  },
  {
    "brand": "Madeira",
    "number": "1721",
    "name": "Flamingo Pink",
    "hex": "#EF3876"
  },
  {
    "brand": "Madeira",
    "number": "1722",
    "name": "Royal Purple",
    "hex": "#21146E"
  },
  {
    "brand": "Madeira",
    "number": "1723",
    "name": "Flan",
    "hex": "#F7DAAF"
  },
  {
    "brand": "Madeira",
    "number": "1724",
    "name": "Gold Nugget",
    "hex": "#E7C000"
  },
  {
    "brand": "Madeira",
    "number": "1725",
    "name": "Liquid Gold",
    "hex": "#E9A517"
  },
  {
    "brand": "Madeira",
    "number": "1726",
    "name": "Light Brown Sugar",
    "hex": "#BB7F4C"
  },
  {
    "brand": "Madeira",
    "number": "1727",
    "name": "Baby Chick",
    "hex": "#FCE86D"
  },
  {
    "brand": "Madeira",
    "number": "1728",
    "name": "Bark",
    "hex": "#9A7761"
  },
  {
    "brand": "Madeira",
    "number": "1729",
    "name": "Buckskin",
    "hex": "#896456"
  },
  {
    "brand": "Madeira",
    "number": "1730",
    "name": "Cumin",
    "hex": "#744A22"
  },
  {
    "brand": "Madeira",
    "number": "1731",
    "name": "Purple Pearl",
    "hex": "#AE81A2"
  },
  {
    "brand": "Madeira",
    "number": "1733",
    "name": "Blue Jay",
    "hex": "#2367BC"
  },
  {
    "brand": "Madeira",
    "number": "1734",
    "name": "Electric Red",
    "hex": "#ED0204"
  },
  {
    "brand": "Madeira",
    "number": "1735",
    "name": "Lemonade",
    "hex": "#FEDF48"
  },
  {
    "brand": "Madeira",
    "number": "1736",
    "name": "Dark Taupe",
    "hex": "#8D7A74"
  },
  {
    "brand": "Madeira",
    "number": "1738",
    "name": "Champagne",
    "hex": "#DCD1B1"
  },
  {
    "brand": "Madeira",
    "number": "1739",
    "name": "Charcoal",
    "hex": "#505054"
  },
  {
    "brand": "Madeira",
    "number": "1740",
    "name": "Weimaraner",
    "hex": "#53545B"
  },
  {
    "brand": "Madeira",
    "number": "1741",
    "name": "Gun Metal",
    "hex": "#7B747C"
  },
  {
    "brand": "Madeira",
    "number": "1742",
    "name": "Blue Ink",
    "hex": "#395084"
  },
  {
    "brand": "Madeira",
    "number": "1743",
    "name": "Oxford Blue",
    "hex": "#3B4276"
  },
  {
    "brand": "Madeira",
    "number": "1744",
    "name": "Siamese Cat",
    "hex": "#51423C"
  },
  {
    "brand": "Madeira",
    "number": "1745",
    "name": "Toasted Marshmellow",
    "hex": "#725447"
  },
  {
    "brand": "Madeira",
    "number": "1746",
    "name": "Teal Green",
    "hex": "#29A3BB"
  },
  {
    "brand": "Madeira",
    "number": "1747",
    "name": "Candy Apple Red",
    "hex": "#B3342F"
  },
  {
    "brand": "Madeira",
    "number": "1748",
    "name": "Margarita Lime",
    "hex": "#AED95B"
  },
  {
    "brand": "Madeira",
    "number": "1749",
    "name": "Green Thumb",
    "hex": "#008D11"
  },
  {
    "brand": "Madeira",
    "number": "1750",
    "name": "Christmas Green",
    "hex": "#056647"
  },
  {
    "brand": "Madeira",
    "number": "1751",
    "name": "Emerald Isle",
    "hex": "#026A3F"
  },
  {
    "brand": "Madeira",
    "number": "1752",
    "name": "Cantaloupe",
    "hex": "#F6B973"
  },
  {
    "brand": "Madeira",
    "number": "1753",
    "name": "Penny",
    "hex": "#CC6F29"
  },
  {
    "brand": "Madeira",
    "number": "1754",
    "name": "Raspberry Punch",
    "hex": "#E42A1F"
  },
  {
    "brand": "Madeira",
    "number": "1755",
    "name": "Marmalade",
    "hex": "#F39B05"
  },
  {
    "brand": "Madeira",
    "number": "1756",
    "name": "Pea Green",
    "hex": "#4F5236"
  },
  {
    "brand": "Madeira",
    "number": "1757",
    "name": "Dark Olive",
    "hex": "#56431C"
  },
  {
    "brand": "Madeira",
    "number": "1758",
    "name": "Grizzley Bear",
    "hex": "#552E1B"
  },
  {
    "brand": "Madeira",
    "number": "1759",
    "name": "Medium Camo Green",
    "hex": "#896F10"
  },
  {
    "brand": "Madeira",
    "number": "1760",
    "name": "Antique Blue",
    "hex": "#426581"
  },
  {
    "brand": "Madeira",
    "number": "1761",
    "name": "Dolphin",
    "hex": "#8DA1C0"
  },
  {
    "brand": "Madeira",
    "number": "1762",
    "name": "Deep Ocean",
    "hex": "#173E65"
  },
  {
    "brand": "Madeira",
    "number": "1763",
    "name": "Copper",
    "hex": "#E98B00"
  },
  {
    "brand": "Madeira",
    "number": "1764",
    "name": "Denim",
    "hex": "#2F3E60"
  },
  {
    "brand": "Madeira",
    "number": "1765",
    "name": "Tiger",
    "hex": "#FB7D00"
  },
  {
    "brand": "Madeira",
    "number": "1766",
    "name": "Sailor Blue",
    "hex": "#0E1B79"
  },
  {
    "brand": "Madeira",
    "number": "1767",
    "name": "Ultra Marine",
    "hex": "#081D80"
  },
  {
    "brand": "Madeira",
    "number": "1768",
    "name": "Bamboo Green",
    "hex": "#99A657"
  },
    {
    "brand": "Madeira",
    "number": "1769",
    "name": "Clover",
    "hex": "#497215"
  },
  {
    "brand": "Madeira",
    "number": "1770",
    "name": "Light Emerald Green",
    "hex": "#447140"
  },
  {
    "brand": "Madeira",
    "number": "1771",
    "name": "Whipped Butterscotch",
    "hex": "#EBAF0B"
  },
  {
    "brand": "Madeira",
    "number": "1772",
    "name": "Military Gold",
    "hex": "#E1A300"
  },
  {
    "brand": "Madeira",
    "number": "1773",
    "name": "Autumn Gold",
    "hex": "#A55306"
  },
  {
    "brand": "Madeira",
    "number": "1775",
    "name": "Dark Federal Blue",
    "hex": "#2D6FAB"
  },
  {
    "brand": "Madeira",
    "number": "1776",
    "name": "Independence Blue",
    "hex": "#102F5C"
  },
  {
    "brand": "Madeira",
    "number": "1777",
    "name": "Bright Peach",
    "hex": "#ED7457"
  },
  {
    "brand": "Madeira",
    "number": "1778",
    "name": "Carrot",
    "hex": "#F95E06"
  },
  {
    "brand": "Madeira",
    "number": "1779",
    "name": "Sweet Potato",
    "hex": "#DA502B"
  },
  {
    "brand": "Madeira",
    "number": "1780",
    "name": "Rainforest",
    "hex": "#025D54"
  },
  {
    "brand": "Madeira",
    "number": "1781",
    "name": "Radish",
    "hex": "#810114"
  },
  {
    "brand": "Madeira",
    "number": "1782",
    "name": "Mulberry",
    "hex": "#701820"
  },
  {
    "brand": "Madeira",
    "number": "1783",
    "name": "Dark Raspberry",
    "hex": "#77043E"
  },
  {
    "brand": "Madeira",
    "number": "1784",
    "name": "Merlot",
    "hex": "#560D16"
  },
  {
    "brand": "Madeira",
    "number": "1785",
    "name": "Bordeaux",
    "hex": "#47061C"
  },
  {
    "brand": "Madeira",
    "number": "1786",
    "name": "Hibiscus",
    "hex": "#AB052D"
  },
  {
    "brand": "Madeira",
    "number": "1787",
    "name": "Fuchsia",
    "hex": "#A80146"
  },
  {
    "brand": "Madeira",
    "number": "1788",
    "name": "Dark Magenta",
    "hex": "#6A1256"
  },
  {
    "brand": "Madeira",
    "number": "1789",
    "name": "Plum Drop",
    "hex": "#491B38"
  },
  {
    "brand": "Madeira",
    "number": "1790",
    "name": "Dill Pickle",
    "hex": "#7F6D0B"
  },
  {
    "brand": "Madeira",
    "number": "1791",
    "name": "Brass",
    "hex": "#BA7621"
  },
  {
    "brand": "Madeira",
    "number": "1792",
    "name": "Old Gold",
    "hex": "#BF8A09"
  },
  {
    "brand": "Madeira",
    "number": "1793",
    "name": "Bullfrog",
    "hex": "#654C0B"
  },
  {
    "brand": "Madeira",
    "number": "1794",
    "name": "Field Gear",
    "hex": "#3F3619"
  },
  {
    "brand": "Madeira",
    "number": "1795",
    "name": "Dark Camo Green",
    "hex": "#262311"
  },
  {
    "brand": "Madeira",
    "number": "1796",
    "name": "Aged Moss",
    "hex": "#4F4A14"
  },
  {
    "brand": "Madeira",
    "number": "1797",
    "name": "Calypso Blue",
    "hex": "#0048A3"
  },
  {
    "brand": "Madeira",
    "number": "1798",
    "name": "Bass Green",
    "hex": "#1D1B16"
  },
  {
    "brand": "Madeira",
    "number": "1799",
    "name": "Green Turquoise",
    "hex": "#05B4B6"
  },
  {
    "brand": "Madeira",
    "number": "1800",
    "name": "Emerald Black",
    "hex": "#0C0B0D"
  },
  {
    "brand": "Madeira",
    "number": "1801",
    "name": "Super White",
    "hex": "#ECEBF0"
  },
  {
    "brand": "Madeira",
    "number": "1802",
    "name": "Snow White",
    "hex": "#F1F1EF"
  },
  {
    "brand": "Madeira",
    "number": "1803",
    "name": "Cream White",
    "hex": "#EAE7DF"
  },
  {
    "brand": "Madeira",
    "number": "1804",
    "name": "Natural White",
    "hex": "#EFEFEF"
  },
  {
    "brand": "Madeira",
    "number": "1805",
    "name": "Fluorescent White",
    "hex": "#EAE9F0"
  },
  {
    "brand": "Madeira",
    "number": "1809",
    "name": "Brushed Bronze",
    "hex": "#CDBC31"
  },
  {
    "brand": "Madeira",
    "number": "1810",
    "name": "Gray Haze",
    "hex": "#CBCACE"
  },
  {
    "brand": "Madeira",
    "number": "1811",
    "name": "Chrome",
    "hex": "#C4C4D0"
  },
  {
    "brand": "Madeira",
    "number": "1812",
    "name": "Cement",
    "hex": "#C3BEC0"
  },
  {
    "brand": "Madeira",
    "number": "1815",
    "name": "Baby Pink",
    "hex": "#FBD0D9"
  },
  {
    "brand": "Madeira",
    "number": "1816",
    "name": "Rustic Pink",
    "hex": "#FCB4BF"
  },
  {
    "brand": "Madeira",
    "number": "1817",
    "name": "Pleasant Peach",
    "hex": "#FCBAA2"
  },
  {
    "brand": "Madeira",
    "number": "1818",
    "name": "Powder Pink",
    "hex": "#E7CBC7"
  },
  {
    "brand": "Madeira",
    "number": "1819",
    "name": "Blush Pink",
    "hex": "#FCB1A5"
  },
  {
    "brand": "Madeira",
    "number": "1820",
    "name": "Peach Tea",
    "hex": "#F29975"
  },
  {
    "brand": "Madeira",
    "number": "1821",
    "name": "Terra Cotta",
    "hex": "#9F1407"
  },
  {
    "brand": "Madeira",
    "number": "1822",
    "name": "Coconut Cream",
    "hex": "#E8DFD1"
  },
  {
    "brand": "Madeira",
    "number": "1823",
    "name": "Fluorescent Yellow",
    "hex": "#F8F700"
  },
  {
    "brand": "Madeira",
    "number": "1824",
    "name": "Fluorescent Yellow",
    "hex": "#FEDA00"
  },
  {
    "brand": "Madeira",
    "number": "1825",
    "name": "Summer Sun",
    "hex": "#FFC701"
  },
  {
    "brand": "Madeira",
    "number": "1826",
    "name": "Peach Pie",
    "hex": "#FDC732"
  },
  {
    "brand": "Madeira",
    "number": "1827",
    "name": "Swimming Pool",
    "hex": "#61BCE8"
  },
  {
    "brand": "Madeira",
    "number": "1828",
    "name": "Work Shirt",
    "hex": "#3080C1"
  },
  {
    "brand": "Madeira",
    "number": "1829",
    "name": "Blue Bird",
    "hex": "#02409C"
  },
  {
    "brand": "Madeira",
    "number": "1830",
    "name": "China Blue",
    "hex": "#758FD8"
  },
  {
    "brand": "Madeira",
    "number": "1831",
    "name": "Purple Pansy",
    "hex": "#A154A4"
  },
  {
    "brand": "Madeira",
    "number": "1832",
    "name": "Majestic Purple",
    "hex": "#583794"
  },
  {
    "brand": "Madeira",
    "number": "1833",
    "name": "Heliotrope",
    "hex": "#620261"
  },
  {
    "brand": "Madeira",
    "number": "1834",
    "name": "Amethyst",
    "hex": "#986BA2"
  },
  {
    "brand": "Madeira",
    "number": "1835",
    "name": "Cranberry",
    "hex": "#6C0219"
  },
  {
    "brand": "Madeira",
    "number": "1836",
    "name": "Cappuccino",
    "hex": "#5A3536"
  },
  {
    "brand": "Madeira",
    "number": "1837",
    "name": "Fluorescent Orange",
    "hex": "#F73400"
  },
  {
    "brand": "Madeira",
    "number": "1838",
    "name": "Brick Red",
    "hex": "#B00004"
  },
  {
    "brand": "Madeira",
    "number": "1839",
    "name": "Christmas Red",
    "hex": "#970001"
  },
  {
    "brand": "Madeira",
    "number": "1840",
    "name": "Cadet Grey",
    "hex": "#8B8EA3"
  },
  {
    "brand": "Madeira",
    "number": "1841",
    "name": "Pewter",
    "hex": "#4B4E56"
  },
  {
    "brand": "Madeira",
    "number": "1842",
    "name": "True Blue",
    "hex": "#033BA4"
  },
  {
    "brand": "Madeira",
    "number": "1843",
    "name": "Persian Blue",
    "hex": "#001B6F"
  },
  {
    "brand": "Madeira",
    "number": "1844",
    "name": "Indigo",
    "hex": "#2D2734"
  },
  {
    "brand": "Madeira",
    "number": "1845",
    "name": "Mint",
    "hex": "#5FB796"
  },
  {
    "brand": "Madeira",
    "number": "1846",
    "name": "Dark Teal",
    "hex": "#0284A1"
  },
  {
    "brand": "Madeira",
    "number": "1847",
    "name": "Sea Foam Green",
    "hex": "#20A39A"
  },
  {
    "brand": "Madeira",
    "number": "1848",
    "name": "Lime Green",
    "hex": "#78AE58"
  },
  {
    "brand": "Madeira",
    "number": "1849",
    "name": "Tropical Teal",
    "hex": "#176C6E"
  },
  {
    "brand": "Madeira",
    "number": "1850",
    "name": "Fluorescent Green",
    "hex": "#7AD714"
  },
  {
    "brand": "Madeira",
    "number": "1851",
    "name": "Cadmium Green",
    "hex": "#10613F"
  },
  {
    "brand": "Madeira",
    "number": "1852",
    "name": "Cobalt",
    "hex": "#246E9E"
  },
  {
    "brand": "Madeira",
    "number": "1853",
    "name": "Light Apricot",
    "hex": "#F0C69D"
  },
  {
    "brand": "Madeira",
    "number": "1854",
    "name": "Rain Barrel",
    "hex": "#B08D89"
  },
  {
    "brand": "Madeira",
    "number": "1855",
    "name": "Coffee with Cream",
    "hex": "#B98E63"
  },
  {
    "brand": "Madeira",
    "number": "1856",
    "name": "Burnt Orange",
    "hex": "#C45C30"
  },
  {
    "brand": "Madeira",
    "number": "1857",
    "name": "Chocolate Lab",
    "hex": "#96491D"
  },
  {
    "brand": "Madeira",
    "number": "1858",
    "name": "Chestnut",
    "hex": "#934425"
  },
  {
    "brand": "Madeira",
    "number": "1859",
    "name": "Dark Chocolate",
    "hex": "#553F3B"
  },
  {
    "brand": "Madeira",
    "number": "1860",
    "name": "Pussy Willow",
    "hex": "#C0AFA6"
  },
  {
    "brand": "Madeira",
    "number": "1861",
    "name": "Palomino",
    "hex": "#F7D46E"
  },
  {
    "brand": "Madeira",
    "number": "1862",
    "name": "Rhino",
    "hex": "#94877F"
  },
  {
    "brand": "Madeira",
    "number": "1863",
    "name": "Chamois",
    "hex": "#D8CDAF"
  },
  {
    "brand": "Madeira",
    "number": "1866",
    "name": "Buff",
    "hex": "#FBE791"
  },
  {
    "brand": "Madeira",
    "number": "1867",
    "name": "Fluorescent Yellow",
    "hex": "#E2F57E"
  },
  {
    "brand": "Madeira",
    "number": "1868",
    "name": "Bottle Green",
    "hex": "#058570"
  },
  {
    "brand": "Madeira",
    "number": "1869",
    "name": "Pumpkin Spice",
    "hex": "#E58D00"
  },
  {
    "brand": "Madeira",
    "number": "1870",
    "name": "Orange Sorbet",
    "hex": "#E79D30"
  },
  {
    "brand": "Madeira",
    "number": "1871",
    "name": "Porcelain Blue",
    "hex": "#86B3DE"
  },
  {
    "brand": "Madeira",
    "number": "1872",
    "name": "Brunette",
    "hex": "#7C5844"
  },
  {
    "brand": "Madeira",
    "number": "1874",
    "name": "Baby Blue",
    "hex": "#AABEE2"
  },
  {
    "brand": "Madeira",
    "number": "1878",
    "name": "Tomato Red",
    "hex": "#D70C0D"
  },
  {
    "brand": "Madeira",
    "number": "1879",
    "name": "Oregon Green",
    "hex": "#016162"
  },
  {
    "brand": "Madeira",
    "number": "1880",
    "name": "Deep Lilac",
    "hex": "#732585"
  },
    {
    "brand": "Madeira",
    "number": "1882",
    "name": "Peach Blossom",
    "hex": "#F0BA97"
  },
  {
    "brand": "Madeira",
    "number": "1883",
    "name": "Fluorescent Yellow",
    "hex": "#FEE300"
  },
  {
    "brand": "Madeira",
    "number": "1884",
    "name": "Burly Wood",
    "hex": "#DAB992"
  },
  {
    "brand": "Madeira",
    "number": "1885",
    "name": "Camel",
    "hex": "#B28858"
  },
  {
    "brand": "Madeira",
    "number": "1886",
    "name": "Light Steel",
    "hex": "#D6CAD2"
  },
  {
    "brand": "Madeira",
    "number": "1887",
    "name": "Mince Pie",
    "hex": "#5C2C39"
  },
  {
    "brand": "Madeira",
    "number": "1888",
    "name": "Deep Sky Blue",
    "hex": "#0096B1"
  },
  {
    "brand": "Madeira",
    "number": "1890",
    "name": "Midnight Green",
    "hex": "#005675"
  },
  {
    "brand": "Madeira",
    "number": "1891",
    "name": "Teal Velvet",
    "hex": "#04405C"
  },
  {
    "brand": "Madeira",
    "number": "1892",
    "name": "Robin's Egg",
    "hex": "#64B7C5"
  },
  {
    "brand": "Madeira",
    "number": "1893",
    "name": "Sky Blue",
    "hex": "#56B8E6"
  },
  {
    "brand": "Madeira",
    "number": "1895",
    "name": "Teal Blue",
    "hex": "#0087C0"
  },
  {
    "brand": "Madeira",
    "number": "1896",
    "name": "Liberty",
    "hex": "#035C98"
  },
  {
    "brand": "Madeira",
    "number": "1898",
    "name": "Auburn",
    "hex": "#C2563F"
  },
  {
    "brand": "Madeira",
    "number": "1899",
    "name": "Henna",
    "hex": "#892716"
  },
  {
    "brand": "Madeira",
    "number": "1900",
    "name": "Celadon",
    "hex": "#B2C5A5"
  },
  {
    "brand": "Madeira",
    "number": "1901",
    "name": "Fluorescent Green",
    "hex": "#54AD3B"
  },
  {
    "brand": "Madeira",
    "number": "1902",
    "name": "Hunter Green",
    "hex": "#2A4132"
  },
  {
    "brand": "Madeira",
    "number": "1903",
    "name": "Spruce Green",
    "hex": "#4A5B52"
  },
  {
    "brand": "Madeira",
    "number": "1904",
    "name": "Dark Sage",
    "hex": "#436143"
  },
  {
    "brand": "Madeira",
    "number": "1905",
    "name": "Moss Green",
    "hex": "#44513A"
  },
  {
    "brand": "Madeira",
    "number": "1906",
    "name": "Antique Bronze",
    "hex": "#543B26"
  },
  {
    "brand": "Madeira",
    "number": "1907",
    "name": "Fluorescent Pink",
    "hex": "#FE272F"
  },
  {
    "brand": "Madeira",
    "number": "1908",
    "name": "Fluorescent Pink",
    "hex": "#F60001"
  },
  {
    "brand": "Madeira",
    "number": "1909",
    "name": "Electric Pink",
    "hex": "#F85362"
  },
  {
    "brand": "Madeira",
    "number": "1910",
    "name": "Electric Magenta",
    "hex": "#DC002A"
  },
  {
    "brand": "Madeira",
    "number": "1911",
    "name": "Evening Mist",
    "hex": "#CFB8D5"
  },
  {
    "brand": "Madeira",
    "number": "1915",
    "name": "Bermuda Sand",
    "hex": "#FAC0BE"
  },
  {
    "brand": "Madeira",
    "number": "1917",
    "name": "Dusty Rose",
    "hex": "#E17181"
  },
  {
    "brand": "Madeira",
    "number": "1918",
    "name": "Polished Pewter",
    "hex": "#807D8E"
  },
  {
    "brand": "Madeira",
    "number": "1919",
    "name": "English Rose",
    "hex": "#973647"
  },
  {
    "brand": "Madeira",
    "number": "1920",
    "name": "Light Khaki",
    "hex": "#C9BF75"
  },
  {
    "brand": "Madeira",
    "number": "1921",
    "name": "Bubble Gum Pink",
    "hex": "#F27CA2"
  },
  {
    "brand": "Madeira",
    "number": "1922",
    "name": "Regal Purple",
    "hex": "#2F0E65"
  },
  {
    "brand": "Madeira",
    "number": "1923",
    "name": "Apricot",
    "hex": "#FCC600"
  },
  {
    "brand": "Madeira",
    "number": "1924",
    "name": "Lemon Tart",
    "hex": "#F9DC02"
  },
  {
    "brand": "Madeira",
    "number": "1925",
    "name": "Fluorescent Yellow",
    "hex": "#FED200"
  },
  {
    "brand": "Madeira",
    "number": "1926",
    "name": "Dark Champagne",
    "hex": "#966545"
  },
  {
    "brand": "Madeira",
    "number": "1927",
    "name": "Shiny Penny",
    "hex": "#CDA16A"
  },
  {
    "brand": "Madeira",
    "number": "1928",
    "name": "Natural Suede",
    "hex": "#876B5E"
  },
  {
    "brand": "Madeira",
    "number": "1929",
    "name": "Brown Hare",
    "hex": "#61514E"
  },
  {
    "brand": "Madeira",
    "number": "1930",
    "name": "Bahamas Blue",
    "hex": "#333394"
  },
  {
    "brand": "Madeira",
    "number": "1931",
    "name": "Bittersweet Chocolate",
    "hex": "#453B3F"
  },
  {
    "brand": "Madeira",
    "number": "1932",
    "name": "Summer Sky",
    "hex": "#5CA1C9"
  },
  {
    "brand": "Madeira",
    "number": "1933",
    "name": "Lavender Lilac",
    "hex": "#6C68AE"
  },
  {
    "brand": "Madeira",
    "number": "1934",
    "name": "Royal Blue",
    "hex": "#2377A6"
  },
  {
    "brand": "Madeira",
    "number": "1935",
    "name": "Fluorescent Yellow",
    "hex": "#EBFA00"
  },
  {
    "brand": "Madeira",
    "number": "1936",
    "name": "Mink",
    "hex": "#6C5950"
  },
  {
    "brand": "Madeira",
    "number": "1937",
    "name": "Fluorescent Orange",
    "hex": "#FFA400"
  },
  {
    "brand": "Madeira",
    "number": "1938",
    "name": "Doe Skin",
    "hex": "#B09A8C"
  },
  {
    "brand": "Madeira",
    "number": "1939",
    "name": "Peanut Butter",
    "hex": "#967848"
  },
  {
    "brand": "Madeira",
    "number": "1940",
    "name": "Key Lime",
    "hex": "#D6D90F"
  },
  {
    "brand": "Madeira",
    "number": "1941",
    "name": "Mauve",
    "hex": "#C28889"
  },
  {
    "brand": "Madeira",
    "number": "1942",
    "name": "Rose Gold",
    "hex": "#894843"
  },
  {
    "brand": "Madeira",
    "number": "1943",
    "name": "Dark Periwinkle",
    "hex": "#3E4EAD"
  },
  {
    "brand": "Madeira",
    "number": "1944",
    "name": "Blueberry Smash",
    "hex": "#2A3851"
  },
  {
    "brand": "Madeira",
    "number": "1945",
    "name": "Sienna",
    "hex": "#693F2B"
  },
  {
    "brand": "Madeira",
    "number": "1946",
    "name": "Fluorescent Orange",
    "hex": "#FB7500"
  },
  {
    "brand": "Madeira",
    "number": "1947",
    "name": "Fluorescent Coral",
    "hex": "#F60200"
  },
  {
    "brand": "Madeira",
    "number": "1948",
    "name": "Pink Carnation",
    "hex": "#FD9AA8"
  },
    {
    "brand": "Madeira",
    "number": "1949",
    "name": "Ivory",
    "hex": "#E8DDCF"
  },
  {
    "brand": "Madeira",
    "number": "1950",
    "name": "Fluorescent Green",
    "hex": "#70DD00"
  },
  {
    "brand": "Madeira",
    "number": "1951",
    "name": "Pumpkin Chiffon",
    "hex": "#F2A800"
  },
  {
    "brand": "Madeira",
    "number": "1952",
    "name": "Melon Burst",
    "hex": "#F26606"
  },
  {
    "brand": "Madeira",
    "number": "1953",
    "name": "Powder Blue",
    "hex": "#A9BEDB"
  },
  {
    "brand": "Madeira",
    "number": "1954",
    "name": "Fluorescent Pink",
    "hex": "#FF4402"
  },
  {
    "brand": "Madeira",
    "number": "1955",
    "name": "Citrus Burst",
    "hex": "#F29200"
  },
  {
    "brand": "Madeira",
    "number": "1956",
    "name": "Olive Green",
    "hex": "#918344"
  },
  {
    "brand": "Madeira",
    "number": "1957",
    "name": "Burnt Taupe",
    "hex": "#493426"
  },
  {
    "brand": "Madeira",
    "number": "1958",
    "name": "Cedar Bark",
    "hex": "#764548"
  },
  {
    "brand": "Madeira",
    "number": "1959",
    "name": "Burnished Gold",
    "hex": "#9F8A04"
  },
  {
    "brand": "Madeira",
    "number": "1960",
    "name": "Dusty Blue",
    "hex": "#687FA8"
  },
  {
    "brand": "Madeira",
    "number": "1961",
    "name": "Blue Spruce",
    "hex": "#4E658F"
  },
  {
    "brand": "Madeira",
    "number": "1962",
    "name": "Admiral Blue",
    "hex": "#2A3F58"
  },
  {
    "brand": "Madeira",
    "number": "1963",
    "name": "Dusty Plum",
    "hex": "#363B63"
  },
  {
    "brand": "Madeira",
    "number": "1964",
    "name": "Storm Sky Blue",
    "hex": "#3B4670"
  },
  {
    "brand": "Madeira",
    "number": "1965",
    "name": "Orange Peel",
    "hex": "#F45D00"
  },
  {
    "brand": "Madeira",
    "number": "1966",
    "name": "Pea Coat",
    "hex": "#353E70"
  },
  {
    "brand": "Madeira",
    "number": "1967",
    "name": "Dark Demin",
    "hex": "#505A7D"
  },
  {
    "brand": "Madeira",
    "number": "1968",
    "name": "Green Tea",
    "hex": "#669D50"
  },
  {
    "brand": "Madeira",
    "number": "1969",
    "name": "Army Green",
    "hex": "#524F3E"
  },
  {
    "brand": "Madeira",
    "number": "1970",
    "name": "Emerald Ink",
    "hex": "#203E2C"
  },
  {
    "brand": "Madeira",
    "number": "1971",
    "name": "Saffron",
    "hex": "#FAC902"
  },
  {
    "brand": "Madeira",
    "number": "1972",
    "name": "Fluorescent Yellow",
    "hex": "#FDBE01"
  },
  {
    "brand": "Madeira",
    "number": "1973",
    "name": "Bronze",
    "hex": "#8C4B11"
  },
  {
    "brand": "Madeira",
    "number": "1974",
    "name": "Cinnamon Stick",
    "hex": "#772322"
  },
  {
    "brand": "Madeira",
    "number": "1975",
    "name": "Colonial Blue",
    "hex": "#1F3D7D"
  },
  {
    "brand": "Madeira",
    "number": "1976",
    "name": "Night Sky",
    "hex": "#212D46"
  },
  {
    "brand": "Madeira",
    "number": "1977",
    "name": "Peacock Blue",
    "hex": "#049DC4"
  },
  {
    "brand": "Madeira",
    "number": "1978",
    "name": "Fluorescent Orange",
    "hex": "#FF7D4F"
  },
  {
    "brand": "Madeira",
    "number": "1979",
    "name": "Dark Amazon",
    "hex": "#144937"
  },
  {
    "brand": "Madeira",
    "number": "1980",
    "name": "Sunflower",
    "hex": "#FFD506"
  },
  {
    "brand": "Madeira",
    "number": "1981",
    "name": "Carmine",
    "hex": "#740313"
  },
  {
    "brand": "Madeira",
    "number": "1982",
    "name": "Sangria",
    "hex": "#7B0311"
  },
  {
    "brand": "Madeira",
    "number": "1983",
    "name": "Eggplant",
    "hex": "#50313B"
  },
  {
    "brand": "Madeira",
    "number": "1984",
    "name": "Orchid",
    "hex": "#C52F50"
  },
  {
    "brand": "Madeira",
    "number": "1985",
    "name": "Deep Rainforest",
    "hex": "#134846"
  },
  {
    "brand": "Madeira",
    "number": "1986",
    "name": "Ripe Raspberry",
    "hex": "#A8001F"
  },
  {
    "brand": "Madeira",
    "number": "1987",
    "name": "Paprika",
    "hex": "#C60000"
  },
  {
    "brand": "Madeira",
    "number": "1988",
    "name": "Kelly Green",
    "hex": "#0A9445"
  },
  {
    "brand": "Madeira",
    "number": "1989",
    "name": "Leaf",
    "hex": "#009060"
  },
  {
    "brand": "Madeira",
    "number": "1990",
    "name": "Pink Rose",
    "hex": "#DB3D7F"
  },
  {
    "brand": "Madeira",
    "number": "1991",
    "name": "Malachite",
    "hex": "#076184"
  },
  {
    "brand": "Madeira",
    "number": "1992",
    "name": "Rough Caribbean Sea",
    "hex": "#014279"
  },
  {
    "brand": "Madeira",
    "number": "1993",
    "name": "Watermelon",
    "hex": "#DF0E31"
  },
  {
    "brand": "Madeira",
    "number": "1994",
    "name": "Lipstick Rose",
    "hex": "#F4444E"
  },
  {
    "brand": "Madeira",
    "number": "1995",
    "name": "Fluorescent Yellow",
    "hex": "#FDED01"
  },
  {
    "brand": "Madeira",
    "number": "1996",
    "name": "Deep Emerald",
    "hex": "#2B3E3F"
  },
  {
    "brand": "Madeira",
    "number": "1997",
    "name": "Plum Pudding",
    "hex": "#302731"
  },
  {
    "brand": "Madeira",
    "number": "1998",
    "name": "Dark Mauve",
    "hex": "#804F54"
  },
  {
    "brand": "Madeira",
    "number": "1999",
    "name": "Raisin",
    "hex": "#702C2A"
  },
    {
    "brand": "ProWrap",
    "number": "101",
    "name": "Yellow Fin",
    "hex": "#FEFC7E"
  },
  {
    "brand": "ProWrap",
    "number": "110",
    "name": "Banana Split",
    "hex": "#FDE97B"
  },
  {
    "brand": "ProWrap",
    "number": "119",
    "name": "Taxi Cab",
    "hex": "#FED55C"
  },
  {
    "brand": "ProWrap",
    "number": "122",
    "name": "Neon Yellow",
    "hex": "#F5FA34"
  },
  {
    "brand": "ProWrap",
    "number": "207",
    "name": "Gold Fish",
    "hex": "#F69A2B"
  },
  {
    "brand": "ProWrap",
    "number": "210",
    "name": "Burnt Orange",
    "hex": "#E47C2C"
  },
  {
    "brand": "ProWrap",
    "number": "213",
    "name": "Clay",
    "hex": "#FD9524"
  },
  {
    "brand": "ProWrap",
    "number": "216",
    "name": "Tangerine",
    "hex": "#E93211"
  },
  {
    "brand": "ProWrap",
    "number": "225",
    "name": "Neon Orange",
    "hex": "#FEA54A"
  },
  {
    "brand": "ProWrap",
    "number": "301",
    "name": "Bubblegum",
    "hex": "#FEBCD5"
  },
  {
    "brand": "ProWrap",
    "number": "307",
    "name": "Fuchsia",
    "hex": "#D06285"
  },
  {
    "brand": "ProWrap",
    "number": "313",
    "name": "Rose",
    "hex": "#EF3160"
  },
  {
    "brand": "ProWrap",
    "number": "316",
    "name": "Raspberry",
    "hex": "#D01933"
  },
  {
    "brand": "ProWrap",
    "number": "319",
    "name": "Redfish",
    "hex": "#F23B31"
  },
  {
    "brand": "ProWrap",
    "number": "325",
    "name": "Fire Red",
    "hex": "#CB1E1A"
  },
  {
    "brand": "ProWrap",
    "number": "331",
    "name": "Mars Red",
    "hex": "#AB2B20"
  },
  {
    "brand": "ProWrap",
    "number": "337",
    "name": "Cranberry",
    "hex": "#7D2327"
  },
  {
    "brand": "ProWrap",
    "number": "343",
    "name": "Burgundy",
    "hex": "#971B2D"
  },
  {
    "brand": "ProWrap",
    "number": "349",
    "name": "Merlot",
    "hex": "#7B283E"
  },
  {
    "brand": "ProWrap",
    "number": "361",
    "name": "Neon Pink",
    "hex": "#FE6293"
  },
  {
    "brand": "ProWrap",
    "number": "404",
    "name": "Teal",
    "hex": "#6FC5DE"
  },
  {
    "brand": "ProWrap",
    "number": "407",
    "name": "Cool Mint",
    "hex": "#63AF89"
  },
  {
    "brand": "ProWrap",
    "number": "413",
    "name": "Island Lagoon",
    "hex": "#58C2B1"
  },
  {
    "brand": "ProWrap",
    "number": "416",
    "name": "Denim",
    "hex": "#2B80AA"
  },
  {
    "brand": "ProWrap",
    "number": "422",
    "name": "Bluegill",
    "hex": "#3A578A"
  },
  {
    "brand": "ProWrap",
    "number": "425",
    "name": "Blue Suede",
    "hex": "#6A89C6"
  },
  {
    "brand": "ProWrap",
    "number": "428",
    "name": "Summer Sky",
    "hex": "#4685B1"
  },
  {
    "brand": "ProWrap",
    "number": "431",
    "name": "Tidal Pool",
    "hex": "#3D83A4"
  },
  {
    "brand": "ProWrap",
    "number": "434",
    "name": "Maui Surf",
    "hex": "#49CBDB"
  },
  {
    "brand": "ProWrap",
    "number": "440",
    "name": "Cool Azul",
    "hex": "#40687C"
  },
  {
    "brand": "ProWrap",
    "number": "446",
    "name": "Regal Blue",
    "hex": "#2E6DBC"
  },
  {
    "brand": "ProWrap",
    "number": "449",
    "name": "Wild Blueberry",
    "hex": "#3B69BE"
  },
  {
    "brand": "ProWrap",
    "number": "455",
    "name": "Cobalt",
    "hex": "#3B69BE"
  },
  {
    "brand": "ProWrap",
    "number": "464",
    "name": "Blurple",
    "hex": "#3A398E"
  },
  {
    "brand": "ProWrap",
    "number": "470",
    "name": "Blue Marlin",
    "hex": "#283962"
  },
  {
    "brand": "ProWrap",
    "number": "479",
    "name": "Gulfstream",
    "hex": "#4A4B66"
  },
  {
    "brand": "ProWrap",
    "number": "484",
    "name": "Deep Sea",
    "hex": "#214158"
  },
  {
    "brand": "ProWrap",
    "number": "501",
    "name": "Kiwi",
    "hex": "#6A8A32"
  },
  {
    "brand": "ProWrap",
    "number": "507",
    "name": "Pea Soup",
    "hex": "#80892F"
  },
  {
    "brand": "ProWrap",
    "number": "510",
    "name": "Sage",
    "hex": "#4B5538"
  },
  {
    "brand": "ProWrap",
    "number": "513",
    "name": "Guacamole",
    "hex": "#4C7032"
  },
  {
    "brand": "ProWrap",
    "number": "519",
    "name": "Rainforest",
    "hex": "#32653C"
  },
  {
    "brand": "ProWrap",
    "number": "525",
    "name": "Oak Leaf",
    "hex": "#29362A"
  },
    {
    "brand": "ProWrap",
    "number": "528",
    "name": "Jade",
    "hex": "#234D48"
  },
  {
    "brand": "ProWrap",
    "number": "537",
    "name": "Fern",
    "hex": "#274038"
  },
  {
    "brand": "ProWrap",
    "number": "543",
    "name": "Evergreen",
    "hex": "#375540"
  },
  {
    "brand": "ProWrap",
    "number": "552",
    "name": "Neon Green",
    "hex": "#C9FD51"
  },
  {
    "brand": "ProWrap",
    "number": "558",
    "name": "Olive",
    "hex": "#897832"
  },
  {
    "brand": "ProWrap",
    "number": "561",
    "name": "Desert Camo",
    "hex": "#AA8C54"
  },
  {
    "brand": "ProWrap",
    "number": "567",
    "name": "Taupe",
    "hex": "#725E4F"
  },
  {
    "brand": "ProWrap",
    "number": "601",
    "name": "Pale Lavender",
    "hex": "#E9B1C4"
  },
  {
    "brand": "ProWrap",
    "number": "607",
    "name": "Lilac",
    "hex": "#EEBDF2"
  },
  {
    "brand": "ProWrap",
    "number": "610",
    "name": "Orchid",
    "hex": "#A55B93"
  },
  {
    "brand": "ProWrap",
    "number": "613",
    "name": "Plum",
    "hex": "#A23F88"
  },
  {
    "brand": "ProWrap",
    "number": "619",
    "name": "Violet",
    "hex": "#CC38AC"
  },
  {
    "brand": "ProWrap",
    "number": "625",
    "name": "Grape",
    "hex": "#843994"
  },
  {
    "brand": "ProWrap",
    "number": "631",
    "name": "Purple",
    "hex": "#9647C4"
  },
  {
    "brand": "ProWrap",
    "number": "634",
    "name": "Amethyst",
    "hex": "#791D78"
  },
  {
    "brand": "ProWrap",
    "number": "640",
    "name": "Purple Heart",
    "hex": "#693787"
  },
  {
    "brand": "ProWrap",
    "number": "701",
    "name": "Rattan",
    "hex": "#C18B57"
  },
  {
    "brand": "ProWrap",
    "number": "704",
    "name": "Midas Gold",
    "hex": "#FEC868"
  },
  {
    "brand": "ProWrap",
    "number": "710",
    "name": "Bees Wax",
    "hex": "#FA9E4D"
  },
  {
    "brand": "ProWrap",
    "number": "713",
    "name": "Sunset",
    "hex": "#FEA348"
  },
  {
    "brand": "ProWrap",
    "number": "716",
    "name": "Teak",
    "hex": "#FCB358"
  },
  {
    "brand": "ProWrap",
    "number": "722",
    "name": "Almond",
    "hex": "#EE9C48"
  },
  {
    "brand": "ProWrap",
    "number": "728",
    "name": "Desert Sand",
    "hex": "#C57A4E"
  },
  {
    "brand": "ProWrap",
    "number": "740",
    "name": "Copper",
    "hex": "#D35930"
  },
  {
    "brand": "ProWrap",
    "number": "749",
    "name": "Brown",
    "hex": "#7C3B36"
  },
  {
    "brand": "ProWrap",
    "number": "755",
    "name": "Chestnut",
    "hex": "#E5816C"
  },
  {
    "brand": "ProWrap",
    "number": "767",
    "name": "Chocolate",
    "hex": "#A36C61"
  },
  {
    "brand": "ProWrap",
    "number": "805",
    "name": "Cream",
    "hex": "#FFF8F3"
  },
  {
    "brand": "ProWrap",
    "number": "806",
    "name": "Eggshell",
    "hex": "#EDE1DB"
  },
  {
    "brand": "ProWrap",
    "number": "807",
    "name": "White",
    "hex": "#FDFCFC"
  },
  {
    "brand": "ProWrap",
    "number": "813",
    "name": "Silver Shiner",
    "hex": "#ECE1E1"
  },
  {
    "brand": "ProWrap",
    "number": "819",
    "name": "Ghost Grey",
    "hex": "#AD9A98"
  },
  {
    "brand": "ProWrap",
    "number": "822",
    "name": "Silver Smoke",
    "hex": "#B6ADB8"
  },
  {
    "brand": "ProWrap",
    "number": "825",
    "name": "Tin Can",
    "hex": "#BA9EA4"
  },
  {
    "brand": "ProWrap",
    "number": "831",
    "name": "Smoke Screen",
    "hex": "#63545E"
  },
  {
    "brand": "ProWrap",
    "number": "836",
    "name": "Forged Steel",
    "hex": "#86899F"
  },
  {
    "brand": "ProWrap",
    "number": "841",
    "name": "Iron Ore",
    "hex": "#525558"
  },
  {
    "brand": "ProWrap",
    "number": "850",
    "name": "Storm Cloud",
    "hex": "#343D40"
  },
  {
    "brand": "ProWrap",
    "number": "855",
    "name": "Charcoal",
    "hex": "#413236"
  },
  {
    "brand": "ProWrap",
    "number": "856",
    "name": "Soot",
    "hex": "#564234"
  },
  {
    "brand": "ProWrap",
    "number": "860",
    "name": "Night Shade",
    "hex": "#363135"
  },
  {
    "brand": "ProWrap",
    "number": "862",
    "name": "Twilight Black",
    "hex": "#161616"
  },
    {
    "brand": "Fuji NOCP",
    "number": "001",
    "name": "Black",
    "hex": "#222224"
  },
  {
    "brand": "Fuji NOCP",
    "number": "002",
    "name": "White",
    "hex": "#F6F6F6"
  },
  {
    "brand": "Fuji NOCP",
    "number": "003",
    "name": "Green",
    "hex": "#259461"
  },
  {
    "brand": "Fuji NOCP",
    "number": "004",
    "name": "Medium Green",
    "hex": "#94BF5C"
  },
  {
    "brand": "Fuji NOCP",
    "number": "005",
    "name": "Scarlet",
    "hex": "#F82E32"
  },
  {
    "brand": "Fuji NOCP",
    "number": "006",
    "name": "Maroon",
    "hex": "#BB1C60"
  },
  {
    "brand": "Fuji NOCP",
    "number": "007",
    "name": "Garnet",
    "hex": "#B02A1C"
  },
  {
    "brand": "Fuji NOCP",
    "number": "008",
    "name": "Dark Blue",
    "hex": "#0029D4"
  },
  {
    "brand": "Fuji NOCP",
    "number": "009",
    "name": "Royal Blue",
    "hex": "#1869EF"
  },
  {
    "brand": "Fuji NOCP",
    "number": "010",
    "name": "Blue Dun",
    "hex": "#30747D"
  },
  {
    "brand": "Fuji NOCP",
    "number": "011",
    "name": "Chestnut",
    "hex": "#9E4F3A"
  },
  {
    "brand": "Fuji NOCP",
    "number": "012",
    "name": "Dark Brown",
    "hex": "#774548"
  },
  {
    "brand": "Fuji NOCP",
    "number": "013",
    "name": "Yellow",
    "hex": "#FEED4B"
  },
  {
    "brand": "Fuji NOCP",
    "number": "014",
    "name": "Golden Rod",
    "hex": "#F5CD06"
  },
  {
    "brand": "Fuji NOCP",
    "number": "015",
    "name": "Orange",
    "hex": "#FB7D0F"
  },
  {
    "brand": "Fuji NOCP",
    "number": "016",
    "name": "Purple",
    "hex": "#490B96"
  },
  {
    "brand": "Fuji NOCP",
    "number": "017",
    "name": "Teal",
    "hex": "#04DDC5"
  },
  {
    "brand": "Fuji NOCP",
    "number": "018",
    "name": "Navy",
    "hex": "#022B64"
  },
  {
    "brand": "Fuji NOCP",
    "number": "019",
    "name": "Light Grey",
    "hex": "#B2B2B2"
  },
  {
    "brand": "Fuji NOCP",
    "number": "020",
    "name": "Candy Apple Red",
    "hex": "#DC2507"
  },
  {
    "brand": "Fuji NOCP",
    "number": "021",
    "name": "Light Blue",
    "hex": "#7AA7E3"
  },
  {
    "brand": "Fuji NOCP",
    "number": "022",
    "name": "Hot Pink",
    "hex": "#FA64AE"
  },
  {
    "brand": "Fuji NOCP",
    "number": "501",
    "name": "Neon Orange",
    "hex": "#FD9849"
  },
  {
    "brand": "Fuji NOCP",
    "number": "502",
    "name": "Neon Pink",
    "hex": "#FD546B"
  },
  {
    "brand": "Fuji NOCP",
    "number": "503",
    "name": "Neon Green",
    "hex": "#CBED8C"
  },
  {
    "brand": "Fuji NOCP",
    "number": "504",
    "name": "Neon Lime",
    "hex": "#B9E968"
  },
  {
    "brand": "Fuji NOCP",
    "number": "023",
    "name": "BC Gray",
    "hex": "#A19F92"
  },
   {
    "brand": "Fuji NOCP",
    "number": "024",
    "name": "Maui Wowie",
    "hex": "#218D94"
  },
  {
    "brand": "Fuji NOCP",
    "number": "025",
    "name": "Bracket Blue",
    "hex": "#B7C4D1"
  },
  {
    "brand": "Fuji NOCP",
    "number": "026",
    "name": "Moss Brown",
    "hex": "#6A6B4E"
  },
  {
    "brand": "Fuji NOCP",
    "number": "027",
    "name": "Moss Green",
    "hex": "#494F33"
  },
  {
    "brand": "Fuji NOCP",
    "number": "028",
    "name": "Olive Green",
    "hex": "#827F41"
  },
  {
    "brand": "Fuji NOCP",
    "number": "029",
    "name": "Desert Tan",
    "hex": "#BF8737"
  },
  {
    "brand": "Fuji NOCP",
    "number": "030",
    "name": "Secret Squirrel",
    "hex": "#B16C38"
  },
  {
    "brand": "Fuji NOCP",
    "number": "031",
    "name": "Midnight",
    "hex": "#1A3251"
  },
  {
    "brand": "Fuji NOCP",
    "number": "032",
    "name": "Tactical Tan",
    "hex": "#A58648"
  },
  {
    "brand": "Fuji NOCP",
    "number": "033",
    "name": "Flat Dark Earth",
    "hex": "#7E5817"
  },
  {
    "brand": "Fuji NOCP",
    "number": "034",
    "name": "OG Green",
    "hex": "#4E6940"
  },
  {
    "brand": "Fuji NOCP",
    "number": "035",
    "name": "Aquamarine",
    "hex": "#0E5765"
  },
  {
    "brand": "Fuji NOCP",
    "number": "036",
    "name": "Concrete",
    "hex": "#B1A5A7"
  },
  {
    "brand": "Fuji NOCP",
    "number": "037",
    "name": "Rain Cloud",
    "hex": "#6E6566"
  },
  {
    "brand": "Fuji NOCP",
    "number": "038",
    "name": "Purple Haze",
    "hex": "#4A3879"
  },
  {
    "brand": "Fuji NOCP",
    "number": "039",
    "name": "Cobalt Blue",
    "hex": "#3C4081"
  },
  {
    "brand": "Fuji NOCP",
    "number": "040",
    "name": "Bubblegum Pink",
    "hex": "#F9B8DA"
  },
  {
    "brand": "Fuji NOCP",
    "number": "041",
    "name": "Blurple",
    "hex": "#363372"
  },
  {
    "brand": "Fuji NOCP",
    "number": "042",
    "name": "Taxi Cab Yellow",
    "hex": "#FFE030"
  },
  {
    "brand": "Fuji NOCP",
    "number": "043",
    "name": "Cheddar",
    "hex": "#FEB029"
  },
  {
    "brand": "Fuji NOCP",
    "number": "044",
    "name": "Spring Green",
    "hex": "#B7C853"
  },
  {
    "brand": "Fuji NOCP",
    "number": "045",
    "name": "Cork",
    "hex": "#D8C17B"
  },
    {
    "brand": "Fuji NOCP",
    "number": "046",
    "name": "DK Fire Coral",
    "hex": "#F64630"
  },
  {
    "brand": "Fuji NOCP",
    "number": "047",
    "name": "Haybale",
    "hex": "#C6BA70"
  },
  {
    "brand": "Fuji NOCP",
    "number": "048",
    "name": "Sea Breeze",
    "hex": "#509EB3"
  },
  {
    "brand": "Fuji NOCP",
    "number": "049",
    "name": "Diet Peach",
    "hex": "#D4A48F"
  },
  {
    "brand": "Fuji NOCP",
    "number": "050",
    "name": "Old Yeller",
    "hex": "#D6A95A"
  },
  {
    "brand": "Fuji NOCP",
    "number": "051",
    "name": "Beige",
    "hex": "#CBBE9B"
  },
  {
    "brand": "Fuji NOCP",
    "number": "052",
    "name": "Periwinkle",
    "hex": "#748CC7"
  },
{
  "brand": "Fuji NOCP",
  "number": "053",
  "name": "Lavender",
  "hex": "#8967A6"
},
{
  "brand": "Fuji NOCP",
  "number": "054",
  "name": "Cabernet",
  "hex": "#B15149"
},
{
  "brand": "Fuji NOCP",
  "number": "055",
  "name": "Run Forrest",
  "hex": "#1F9851"
},
{
  "brand": "Fuji NOCP",
  "number": "056",
  "name": "Swamp Purple",
  "hex": "#6F3486"
},
{
  "brand": "Fuji NOCP",
  "number": "057",
  "name": "Cerulean Blue",
  "hex": "#459DCB"
},
{
  "brand": "Fuji NOCP",
  "number": "059",
  "name": "Fazlite",
  "hex": "#2F5466"
}
];